import type { Layout } from "react-grid-layout";

import { peekCached } from "@/lib/requestCache";
import {
  HOME_LAYOUT_CACHE_KEY,
  METRICS_CATALOG_CACHE_KEY,
  api,
} from "@/services/api";
import type { MetricsCatalog } from "@/types/metrics";
import type { HomeLayout, HomeWidget } from "@/types/home";

import {
  homeWidgetToGridWidget,
  hydrateHomeWidgets,
} from "./homeWidgets";
import { widgetsToRglLayout } from "@/features/dashboard/grid/layoutUtils";

export interface HomeLayoutSnapshot {
  catalog: MetricsCatalog | null;
  widgets: HomeWidget[];
  rglLayout: Layout[];
}

/** Synchronously hydrate editor state from a warm request-cache entry. */
export function peekHomeLayoutSnapshot(): HomeLayoutSnapshot | null {
  const home = peekCached<HomeLayout>(HOME_LAYOUT_CACHE_KEY);
  if (!home) return null;
  const rawWidgets = home.widgets ?? [];
  const widgets = hydrateHomeWidgets(rawWidgets);
  const rglLayout = widgetsToRglLayout(
    widgets.map(homeWidgetToGridWidget),
    home.layout,
  );
  return {
    catalog: peekCached(METRICS_CATALOG_CACHE_KEY) ?? null,
    widgets,
    rglLayout,
  };
}

/** Warm the Home dashboard chunk + layout payloads on nav hover. */
export function prefetchHomeDashboardData(): void {
  void api.getHomeLayout().catch(() => {});
  void api.getMetricsCatalog().catch(() => {});
}
